import { compose, prop, propOr, isNil } from 'ramda';

export const selectLocation = prop('location');

export const selectQuery = compose(propOr({}, 'query'), selectLocation);
export const selectPayload = compose(propOr({}, 'payload'), selectLocation);
export const selectParams = (state) => ({
  product: 'waybetter', // default product
  ...selectPayload(state),
  ...selectQuery(state),
});

export const selectPlainFlag = compose(
  ({ plain }) => !isNil(plain),
  selectQuery
);

export const selectPage = compose(
  ({ routesMap, type }) => routesMap[type],
  selectLocation
);

export const isDynamicPage = compose((page) => !!page.dynamic, selectPage);

export const selectPreviousPage = (state) => {
  const { routesMap, prev } = selectLocation(state);
  const previousPage = routesMap[prev.type];

  return previousPage;
};

export const selectPageComponent = compose(prop('component'), selectPage);

export const selectPageComponentNamespace = compose(
  prop('componentNamespace'),
  selectPage
);

export const selectPageOptions = compose(prop('options'), selectPage);
